import type { RootState } from '@/store';

export const selectChecklistDispensado = (state: RootState): boolean | null =>
  state.preferenciasUi.checklistDispensado;

export const selectChecklistSetoresConcluido = (state: RootState): boolean =>
  state.preferenciasUi.checklistSetoresConcluido;
